import { LoggerContext } from "@emed-labs/platform-utility-logger-context";
import React from "react";

export interface VUMeterProps {
	audioInputDeviceID: string;

	onAudioLevelChange?: (rms: number) => void;
	onAudioDeviceError?: (error: Error) => void;
}

export interface VUMeterState {
	rmsValue?: number;
}

const LOGGER = LoggerContext.create("ui.VUMeter");
export class VUMeter extends React.Component<VUMeterProps, VUMeterState> {
	currentStream: MediaStream;
	audioContext: AudioContext;
	isClosing: boolean = false;

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.startAudioInput();
	}

	componentDidUpdate(prevProps: Readonly<VUMeterProps>, prevState: Readonly<VUMeterState>, snapshot?: any) {
		if (this.props.audioInputDeviceID !== prevProps.audioInputDeviceID) {
			this.startAudioInput();
		}
	}

	componentWillUnmount() {
		this.isClosing = true;
		this.stopAudioInput();
	}

	async startAudioInput() {
		try {
			await this.stopAudioInput();

			if (!this.props.audioInputDeviceID) {
				return;
			}
			this.currentStream = await navigator.mediaDevices.getUserMedia({
				audio: {
					deviceId: { exact: this.props.audioInputDeviceID ?? null }
				}
			});

			const AudioContext = window.AudioContext || (window as any).webkitAudioContext;

			this.audioContext = new AudioContext();
			const mediaStreamSource = this.audioContext.createMediaStreamSource(this.currentStream);
			const processor = this.audioContext.createScriptProcessor(2048, 1, 1);

			mediaStreamSource.connect(processor);
			processor.connect(this.audioContext.destination);

			processor.onaudioprocess = (e) => {
				if (this.isClosing) {
					return;
				}

				const inputData = e.inputBuffer.getChannelData(0);
				const inputDataLength = inputData.length;
				let total = 0;

				for (let i = 0; i < inputDataLength; i++) {
					total += Math.abs(inputData[i++]);
				}

				const rms = Math.sqrt(total / inputDataLength);

				this.setState({
					rmsValue: rms
				});

				if (this.props.onAudioLevelChange) {
					this.props.onAudioLevelChange(rms);
				}
			};
		} catch (e) {
			LOGGER.error("VUMeter", `startAudioInput Error: ${e.message}`, e);
			if (this.props.onAudioDeviceError) {
				this.props.onAudioDeviceError(e);
			}
		}
	}

	async stopAudioInput() {
		if (this.audioContext) {
			await this.audioContext.close();
			this.audioContext = null;
		}

		if (this.currentStream) {
			const theStream = this.currentStream;
			this.currentStream = null;
			theStream.getAudioTracks().map((track) => {
				try {
					track.stop();
				} catch (e) {}
			});
		}
	}

	render() {
		const percentage = (this.state.rmsValue ?? 0) * 100;
		return (
			<progress className="progress is-danger" value={percentage} max={100}>
				{percentage}
			</progress>
		);
	}
}
